import { useFetcher } from 'react-router';
import { Asleep, Light, Laptop } from '@carbon/icons-react';
import { useOptimisticThemeMode } from '../routes/resources/theme-switch.tsx';

export function ThemeSwitcherAction({
  userPreference,
}: {
  userPreference?: 'light' | 'dark' | 'system' | null;
}) {
  const fetcher = useFetcher();

  const optimisticMode = useOptimisticThemeMode();
  const mode = optimisticMode ?? userPreference ?? 'system';
  const nextMode =
    mode === 'system' ? 'light' : mode === 'light' ? 'dark' : 'system';

  // Show icon for CURRENT mode (what you're in now)
  const currentIcon =
    mode === 'light' ? (
      <Light size={20} className="text-white/70! hover:text-white!" />
    ) : mode === 'dark' ? (
      <Asleep size={20} className="text-white/70! hover:text-white!" />
    ) : (
      <Laptop size={20} className="text-white/70! hover:text-white!" />
    );

  const modeLabel =
    mode === 'light' ? 'Light' : mode === 'dark' ? 'Dark' : 'System';

  return (
    <fetcher.Form
      method="POST"
      action="/resources/theme-switch"
      className="theme-switcher-form"
    >
      <input type="hidden" name="theme" value={nextMode} />
      <button
        type="submit"
        className="cds--header__action"
        aria-label={`${modeLabel} mode (click to switch to ${nextMode})`}
        title={`Switch to ${nextMode} mode`}
      >
        {currentIcon}
      </button>
    </fetcher.Form>
  );
}
